import { Ciudad } from 'src/app/pago/models/Ciudad.model';
import { Departamento } from 'src/app/pago/models/Departamento.model';
import { Maestro } from 'src/app/pago/models/Maestro.model';

export interface MaestrosState {
  tiposDeDocumento: Maestro[];
  ciudades: Ciudad[];
  departamentos: Departamento[];
}

export const initialMaestrosState: MaestrosState = {
  tiposDeDocumento: [],
  ciudades: [],
  departamentos: [],
};
